import _mapValues from 'lodash/mapValues';
import _map from 'lodash/map';
import {CancelToken} from 'axios';
import {CLEnumType, CLRemoteEnums} from './enums.types';
import {toLocalEnum} from './enums.dataConverters';
import apiV2Service from '../api/api-v2.service';

const basePath = 'Enums';

const enumsApi = {
  get: async (enumType: CLEnumType, cancelToken?: CancelToken) => {
    const {
      data: remoteEnums,
    } = await apiV2Service.executeGetRequest<CLRemoteEnums>(
      `${basePath}/${CLEnumType[enumType]}`,
      {},
      {cancelToken},
    );

    return _mapValues(remoteEnums.optionsPerEnum, (enumValues) => _map(enumValues, toLocalEnum));
  },
};

export default enumsApi;
